import React from 'react';
import styled from '@emotion/styled';
import { CtvPlayer } from './player/CtvPlayer';
import { Remote } from './remote/Remote';

export const Preview: React.FunctionComponent<{}> = () =>{
  return <PreviewContainer>
    <PreviewContentContainer>
      <CtvPlayer/>
      <Remote/>
    </PreviewContentContainer>
  </PreviewContainer>;
}



const PreviewContentContainer = styled.div`
    position: relative;
    left: 3%;
    height: 90%;
    width: 90%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
`;

const PreviewContainer = styled.div`
  background-color: #E2E2E2;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;
